/* eslint-disable */
// 兼容 IE 9
import "babel-polyfill";
// IE matches
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}
